<template>
  <nav>
    <ul class="nav-ui">
      <!-- <li class="nav-li"><a href="/" class="active">今日商务舱</a> </li>
      <li class="nav-li"><a href="/prinress">今日经济舱</a></li>
      <li class="nav-li"><a href="/contact">联系方式</a></li>
      <li class="nav-li"><a href="/about">服务介绍</a></li> selectNavItem(index,item.href)
      <li class="nav-li"><a href="/vip">成为VIP</a></li> --> 

      <li v-for="(item, index) in navItems" :key="index" lass="nav-li" >
        <a :href="item.href" @click.prevent="selectNavItem(index,item.href)" :class="{ active: activeIndex === index }">
          {{ item.title }}
        </a>
      </li>
    </ul>
  </nav>
</template>

<script> 
import{ mapState ,mapGetters,mapMutations} from  'vuex';

export default{
  data(){
    return{ 
      navItems:[
        {title:'今日商务舱',href:'/'},
        // {title:'今日经济舱',href:'/prinress'},
        {title:'联系方式',href:'/contact'},
        {title:'服务介绍',href:'/about'},
        {title:'招聘合作',href:'/recuruiment'}
        // {title:'成为VIP',href:'/vip'}
      ],
    }
  },
  computed:{
    ...mapState(['activeIndex']),
    ...mapGetters(['getActiveIndex']),
    ...mapMutations(['setActiveIndex'])
  },
 
  methods:{
    // ...mapActions(['updateActiveIndex']),
    selectNavItem(index,href) {     
      this.$router.push(href); 
      this.$store.dispatch('updateActiveIndex', index);
      // this.$store.commit('setActiveIndex',index);   
    }
  }
}
 
</script>

<style lang="scss" scoped>
@mixin wpforms-field-border-rad{
    background: -webkit-linear-gradient(43deg, #c1924e, #f6eca5 80%) !important;
    -webkit-background-clip: text !important;
    -webkit-text-fill-color: transparent;
}
@mixin wpnav-font-size{
    font: normal bold 17px / 21px "Roboto", Helvetica, Arial, Verdana, sans-serif;
    text-transform: none;
}

@mixin wpnav-li-a{
  display: flex;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  -webkit-align-content: center;
  -moz-align-content: center;
  -ms-align-content: center;
  align-content: center;
  -ms-flex-line-pack: stretch;
}

@mixin flex-align-center{
  -webkit-flex: 1 1 100%;
  -moz-flex: 1 1 100%;
  -ms-flex: 1 1 100%;
  flex: 1 1 100%;
  -ms-flex-positive: 1;
  -ms-flex-negative: 1;
  -ms-flex-preferred-size: 100%;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flexbox;
  display: -ms-flex;
  display: flex;
  -webkit-flex-flow: row wrap;
  -moz-flex-flow: row wrap;
  -ms-flex-flow: row wrap;
  flex-flow: row wrap;
  -webkit-align-items: center;
  -moz-align-items: center;
  -ms-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
@mixin justify-content{
  -webkit-justify-content: center;
  -moz-justify-content: center;
  -ms-flex-pack: center;
  -ms-justify-content: center;
  justify-content: center;
}
@mixin position-relative{
  position: relative;
}
@mixin margin0{
  margin: 0 0 0 0;
}

@mixin flex-stretch{
  -webkit-align-items: stretch;
  -moz-align-items: stretch;
  -ms-align-items: stretch;
  -ms-flex-align: stretch;
  align-items: stretch;
  -webkit-align-content: stretch;
  -moz-align-content: stretch;
  -ms-align-content: stretch;
  align-content: stretch;
}
@mixin wpnav-li-a-mp{
  margin: 0px 0px 15px 0px;
  padding: 10px 4px 10px 4px; 
}

$wpnav-text-color:-webkit-linear-gradient(43deg, #c1924e, #f6eca5 80%) !important;
$underline-duration: 0.3s;
$underline-color: #000;

@media screen and (max-width: 530px)  {
  .nav-li{
    margin-left: 15px !important;
    margin-right: 1rem !important;
  } 
}
 

nav{ 
  @include position-relative;
  @include margin0;
  @include justify-content;
  @include flex-align-center;
  @include flex-stretch;
  z-index:99;
  ul {
      list-style-type: none;
      padding-inline-start: 0px !important; 
      @include margin0;
      @include flex-align-center; 
      @include flex-stretch;
      @include justify-content;
      li {
        @include position-relative;
        margin-right: 1.5rem;
        a {
          @include wpforms-field-border-rad;
          @include  wpnav-font-size;
          @include wpnav-li-a;
          @include wpnav-li-a-mp;
          &::after {
            content: "";
            position: absolute;
            bottom: 1rem;
            left: 0;
            width: 0%;
            height: 0.2rem;
            background: $wpnav-text-color;
            transition: width $underline-duration, background-size $underline-duration;
          }
          &.active,
          &:hover {
            // color: $underline-color;
            &::after {
              width: 100%;
              background-size: 200% 100%;
              background-position: left center;
            }
          }
        }
      }
    }
  }
</style>


